import { useMemo } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import WIZARD_CODES from 'lib/constants/wizard/wizard_codes';

import Stepper from '../Stepper/Stepper';

import Intro from './components/Intro';
import { tourSteps } from './lib/helpers';
import componentSteps from './lib/componentSteps';
import STEP_DEFINITIONS from './lib/stepDefinitions';
import SUBSTEP_DEFINITIONS from './lib/substepDefinitions';

const OnboardingWizard = () => {
  const navigate = useNavigate();
  const { practice } = useOutletContext();

  const hiddenSubstepCodes = useMemo(() => {
    const codes = new Set();
    if (!practice?.organization?.id) {
      codes.add(SUBSTEP_DEFINITIONS[STEP_DEFINITIONS.DATA_IMPORT.code].ORGANIZATION.code);
    }
    return codes;
  }, [practice?.organization?.id]);

  return (
    <>
      <Stepper
        IntroComponent={
          <Intro
            title="Myriad Health"
            description="A comprehensive practice management system"
            onSkip={() => navigate('/portal')}
          />
        }
        wizardKind={WIZARD_CODES.ONBOARDING}
        LoginComponent={null}
        hiddenSubstepCodes={hiddenSubstepCodes}
        componentStepsConfig={componentSteps}
        tourStepsConfig={tourSteps}
      />
    </>
  );
};

export default OnboardingWizard;
